import React, { useCallback } from 'react';
import { NumberInput } from '@patternfly/react-core';
import ComponentPropTypes from './ComponentPropTypes';
import _ from 'lodash';

const NumberInputComponent = ({ model, value, onChange }) => {
  const setValue = useCallback(newValue => {
    onChange(model, newValue);
  }, [model, onChange]);

  const _onChange = useCallback(e => {
    setValue(e.target.value);
  }, [setValue]);

  const onMinus = useCallback(() => {
    const changedValue = _.subtract(value, 1);
    if (model.properties?.onMinus == null) {
      setValue(changedValue);
    } else {
      model.properties?.onMinus(changedValue, value, setValue);
    }
  }, [model.properties, setValue, value]);

  const onPlus = useCallback(() => {
    const changedValue = _.add(value, 1);
    if (model.properties?.onPlus == null) {
      setValue(changedValue);
    } else {
      model.properties?.onPlus(changedValue, value, setValue);
    }
  }, [model.properties, setValue, value]);

  return (
    <NumberInput
      inputName={model.path}
      inputAriaLabel={model.path}
      value={value ?? ''}
      onChange={_onChange}
      onMinus={onMinus}
      onPlus={onPlus}
      unit={model.properties?.unit}
      unitPosition={model.properties?.unitPosition}
      widthChars={model.properties?.widthChars}
      isDisabled={model.disabled}
    />

  );
};

NumberInputComponent.propTypes = ComponentPropTypes;

export default React.memo(NumberInputComponent);
